import {RestClient} from "@prowin/restclient";
import {
    DELETE_BLACKLIST_ITEM,
    ENDPOINT_APPLICATION_DETAILS,
    ENDPOINT_APPLICATIONS,
    ENDPOINT_APPLICATIONS_STATUS,
    ENDPOINT_EDITORS,
    ENDPOINT_HISTORY,
    ENDPOINT_TRANSLATIONS,
    ENDPOINT_USER_DASHBOARD,
    GET_BLACKLIST,
    POST_APPLICATION_QUESTIONS,
    POST_ENDPOINT_EDITOR_NOTE,
    PUT_CHANGE_EDITOR,
    PUT_ENDPOINT_ABORT,
    PUT_ENDPOINT_DECLINE,
    PUT_ENDPOINT_EDIT_EDITOR_NOTE,
    PUT_TRANSFER_APPLICATION,
    RECRUITMENT_BASE_URL
} from "./fetchConst";

// import {EditorType} from "../Home/LeftFilter/type";

export interface PiralOAuthCustomState {
    accessToken: string,
    impersonated: boolean,
    isUserAuthenticated: boolean,
    jwt: [key: string]
}

class FetchHelper {

    private recruitment: RestClient;
    private applications: RestClient;
    // private app_assignedToMe: RestClient;
    private _oauth: PiralOAuthCustomState;
    private translations: RestClient;
    private blacklist: RestClient;

    constructor(oauth: PiralOAuthCustomState) {
        this._oauth = oauth;
        this.recruitment = new RestClient(RECRUITMENT_BASE_URL!, "Bearer", this._oauth.accessToken);
        this.applications = new RestClient(RECRUITMENT_BASE_URL!, "Bearer", this._oauth.accessToken);
        // this.app_assignedToMe = new RestClient("", "Bearer", this._oauth.accessToken)
        this.translations = new RestClient(RECRUITMENT_BASE_URL!);
        this.blacklist = new RestClient(RECRUITMENT_BASE_URL!, "Bearer", this._oauth.accessToken);
    }

    getEditorsList(): Promise<any> {
        return this.recruitment.get(ENDPOINT_EDITORS()).then(res => res)
    }

    getApplications(searchString?: string): Promise<any> {
        return this.applications.get(ENDPOINT_APPLICATIONS(searchString)).then(res => res)
    }

    getApplicationByStatus(applicationStatus: string): Promise<any> {
        return this.applications.get(ENDPOINT_APPLICATIONS_STATUS(applicationStatus)).then(res => res)
    }

    getApplicationDetails(id: string): Promise<any> {
        return this.applications.get(ENDPOINT_APPLICATION_DETAILS(id)).then(res => res)
    }

    getUserData(): Promise<any> {
        return this.applications.get(ENDPOINT_USER_DASHBOARD()).then(res => res)
    }

    getApplicationAssignedToMe(url: string): Promise<any> {
        return this.applications.get(url).then(res => res)
    }

    getApplicationHistory(id: number): Promise<any> {
        return this.applications.get(ENDPOINT_HISTORY(id)).then(res => res)
    }

    addEditorNote(id: number, note: { editorNote: string }): Promise<any> {
        return this.applications.post(POST_ENDPOINT_EDITOR_NOTE(id), JSON.stringify(note)).then(res => res)
    }

    editEditorNote(id: number, note: { editorNote: string }): Promise<any> {
        return this.applications.put(PUT_ENDPOINT_EDIT_EDITOR_NOTE(id), JSON.stringify(note)).then(res => res)
    }

    declineApplication(id: number, editorExplanation: { editorExplanation: string | null }): Promise<any> {
        return this.applications.put(PUT_ENDPOINT_DECLINE(id), JSON.stringify(editorExplanation)).then(res => res)
    }

    // "editorExplanation": null
    abortApplication(id: number, editorExplanation: { editorExplanation: string | null }): Promise<any> {
        return this.applications.put(PUT_ENDPOINT_ABORT(id), JSON.stringify(editorExplanation)).then(res => res)
    }

    changeApplicationEditor(id: number, applicationEditor: { editor: number }): Promise<any> {
        return this.applications.put(PUT_CHANGE_EDITOR(id), JSON.stringify(applicationEditor)).then(res => res)
    }

    sendApplicationQuestions(id: number, questions: { editorInquiries: string[] }): Promise<any> {
        return this.applications.post(POST_APPLICATION_QUESTIONS(id), JSON.stringify(questions)).then(res => res)
    }

    transferApplication(id: number): Promise<any> {
        return this.applications.put(PUT_TRANSFER_APPLICATION(id)).then(res => res)
    }

    getTranslations(languge: string): Promise<any> {
        return this.translations.get(ENDPOINT_TRANSLATIONS("de")).then(res => res)
    }

    getBlacklist(): Promise<any> {
        return this.blacklist.get(GET_BLACKLIST()).then(res => res);
    }

    deleteBlacklistItem(id: number): Promise<any> {
        return this.blacklist.del(DELETE_BLACKLIST_ITEM(id)).then(res => res);
    }
}

export default FetchHelper;